<template>
    <div class="mt-2">
        <!-- Profile Section -->
        <ProfileSection 
            :user_id="user_id" 
            :product_id="product_id"
            :showMessageButton="$route.name === 'productDetails'"
            @user-loaded="handleUserLoaded"
        />

        <!-- Reviews Section -->
        <ReviewsSection 
            v-if="user"
            :reviews="user.ratings || []"
            :showReviews="showReviews"
        />

        <!-- Products Listings -->
        <ProductsListings 
            v-if="user"
            :sellerProducts="sellerProducts"
            :moreProducts="filteredMoreProducts"
            :username="user.username"
            :userId="user.id"
            :showSellerProducts="$route.name !== 'productManagement' && sellerProducts.length > 0"
            :showMoreProducts="$route.name === 'productDetails' && !showReviews && filteredMoreProducts.length > 0"
        />
    </div>
</template>

<script>
import ProfileSection from '@/components/user/ProfileSection.vue';
import ReviewsSection from '@/components/user/ReviewsSection.vue';
import ProductsListings from '@/components/user/ProductsListings.vue';

export default {
    name: "SellerInformationComp",
    components: {
        ProfileSection,
        ReviewsSection,
        ProductsListings
    },
    props: {
        showReviews: { type: Boolean, default: true },
        user_id: { type: [Number, String], default: null },
        product_id: { type: [Number, String], required: true }
    },
    data() {
        return {
            user: null,
            sellerProducts: [],
            moreProducts: []
        };
    },
    computed: {
        filteredMoreProducts() {
            const sellerIds = this.sellerProducts.map(p => p.id);
            return this.moreProducts.filter(p => !sellerIds.includes(p.id));
        }
    },
    methods: {
        handleUserLoaded(userData) {
            this.user = userData;
            this.sellerProducts = (userData.products || []).filter(
                p => p.is_active && String(p.id) !== String(this.product_id)
            );
            this.getMoreProducts(10);
        },
        getMoreProducts(number) {
            this.$axios({
                url: `product/list/random/${number}/0`,
                method: "GET",
            })
                .then((response) => {
                    this.moreProducts = response.data;
                })
                .catch((err) => {
                    console.error("Error fetching random products:", err);
                    this.moreProducts = [];
                });
        }
    }
};
</script>

<style scoped>
.mt-2 {
    margin-top: 0.5rem;
}
</style>